var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', [_c('b-row', [_c('label', {
    staticClass: "custom-font"
  }, [_c('b', [_vm._v("Personal Task Summary")])]), _c('div', {
    staticClass: "button-style"
  }, [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0 mr-1",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.goTask
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "ClipboardIcon"
    }
  })], 1)], 1)]), this.donutChart.series && this.donutChart.series.length > 0 ? _c('div', [_c('vue-apex-charts', {
    attrs: {
      "type": "donut",
      "height": "350",
      "options": _vm.donutChart.chartOptions,
      "series": _vm.donutChart.series
    },
    on: {
      "dataPointSelection": _vm.onDataPointSelection
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }